<template>
  <el-input-number
    ref="inputNumber"
    v-model="value"
    v-bind="trimAttrs($attrs)"
    :controls-position="isRightControls ? 'right' : ''"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
  />
</template>

<script>
import { InputNumber } from 'element-ui';
export default {
  name: 'JskInputNumber',
  components: {
    ElInputNumber: InputNumber
  },
  inheritAttrs: false,
  model: {
    prop: 'vModel',
    event: 'change'
  },
  props: {
    vModel: Number,
    isRightControls: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      value: ''
    };
  },
  watch: {
    value: function() {
      this.$emit('change', this.value);
      this.$nextTick(() => {
        if (this.value !== this.vModel) {
          this.value = this.vModel;
        }
      });
    },
    vModel: function() {
      this.value = this.vModel;
    }
  },
  created: function() {
    this.value = this.vModel;
  },
  methods: {
    trimAttrs: function(attrs) {
      Object.keys(attrs).forEach((key) => {
        let prefixes = ['is-', 'has-', 'input-number-'];
        prefixes.forEach((prefix) => {
          if (key.substr(0, prefix.length) === prefix) {
            attrs[key.substr(prefix.length)] = attrs[key];
          }
        })
      })
      return attrs;
    },
    focus: function() {
      this.$refs.inputNumber.focus();
    },
    select: function() {
      this.$refs.inputNumber.select();
    }
  }
}
</script>

<style lang="scss" src="../../theme/input-number.scss"></style>
